import "./BonusDocumentTableAux.css";

export interface BonusCondicionalRow {
  valorAnoInicial?: number;
  valorAnoFinal?: number;
  resultado?: number;
}

export interface BonusDocumentTableAuxRow {
  nome?: string;
  documento?: string;
  conforme?: boolean;
  percentual?: number;
  valor?: number;
  bonusCondicional?: BonusCondicionalRow;
}

const getRowLabel = (item: BonusDocumentTableAuxRow) =>
  String(item.nome ?? item.documento ?? "").trim();

export interface BonusDocumentTableAuxProps {
  data: BonusDocumentTableAuxRow[];
  receita?: unknown[];
  associado?: unknown[];
  valor?: number;
  percentualReceita?: unknown;
}

const BonusDocumentTableAux = ({
  data,
  receita = [],
  associado = [],
  valor,
  percentualReceita: _percentualReceita,
}: BonusDocumentTableAuxProps) => {
  const formatCurrency = (value: number | undefined | null) =>
    (value ?? 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

  return (
    <div className="bonus-document-table-aux">
    <table className="bonus-table">
      <thead>
        <tr>
          <th>DOCUMENTO BÔNUS</th>
          <th style={{ textAlign: "center" }}>CUMPRIU?</th>
          <th style={{ textAlign: "center" }}>PERCENTUAL</th>
          <th style={{ textAlign: "center" }}>VALOR</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => {
          const label = getRowLabel(item);
          return (
          <tr key={index}>
            <td>
              <span>{label || "-"}</span>

              {label === "EVOLUÇÃO RECEITA OPERACIONAL" &&
                item.bonusCondicional && (
                  <table className="mini-table">
                    <thead>
                      <tr>
                        <th>2023</th>
                        <th>2024</th>
                        <th>% Evolução</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {formatCurrency(
                            item.bonusCondicional.valorAnoInicial,
                          )}
                        </td>
                        <td>
                          {formatCurrency(item.bonusCondicional.valorAnoFinal)}
                        </td>
                        <td>{item.bonusCondicional.resultado}%</td>
                      </tr>
                    </tbody>
                  </table>
                )}

              {label === "EVOLUÇÃO DO ASSOCIATIVISMO" &&
                item.bonusCondicional && (
                  <table className="mini-table">
                    <thead>
                      <tr>
                        <th>2023</th>
                        <th>2024</th>
                        <th>% Evolução</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{item.bonusCondicional.valorAnoInicial}</td>
                        <td>{item.bonusCondicional.valorAnoFinal}</td>
                        <td>{item.bonusCondicional.resultado}%</td>
                      </tr>
                    </tbody>
                  </table>
                )}

              {label.includes("80% DE RETENÇÃO DE ASSOCIADOS") &&
                item.bonusCondicional && (
                  <table className="mini-table">
                    <thead>
                      <tr>
                        <th>2023</th>
                        <th>2024</th>
                        <th>% Retenção</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{item.bonusCondicional.valorAnoInicial}</td>
                        <td>{item.bonusCondicional.valorAnoFinal}</td>
                        <td>{item.bonusCondicional.resultado}%</td>
                      </tr>
                    </tbody>
                  </table>
                )}
            </td>
            <td style={{ textAlign: "center" }}>
              {item.conforme === true
                ? "SIM"
                : item.conforme === false
                  ? "NÃO"
                  : "-"}
            </td>
            <td style={{ textAlign: "center" }}>{item.percentual}%</td>
            <td style={{ textAlign: "center" }}>
              {formatCurrency(Number(item.valor) || 0)}
            </td>
          </tr>
        );
        })}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={3} className="total-label">
            VALOR TOTAL:
          </td>
          <td className="total-value">{formatCurrency(Number(valor) || 0)}</td>
        </tr>
      </tfoot>
    </table>
    </div>
  );
};

export default BonusDocumentTableAux;
